import React from "react";

import {
    Bike,
    Car,
    CreditCard,
    ShieldCheck
} from "lucide-react";

import "./VehicleForm.css";

function VehicleForm({

    profile,

    setProfile,

}) {

    const handleChange = (e) => {

        const { name, value } = e.target;

        setProfile({

            ...profile,

            vehicle: {

                ...profile.vehicle,

                [name]: value,

            },

        });

    };

    return (

        <div className="edit-card">

            <h2>

                Vehicle Information

            </h2>

            <div className="form-grid">

                <div className="input-group">

                    <label>

                        <Bike size={16}/>

                        Vehicle Type

                    </label>

                    <select

                        name="type"

                        value={profile?.vehicle?.type || ""}

                        onChange={handleChange}

                    >

                        <option value="">

                            Select Vehicle

                        </option>

                        <option value="Bike">

                            Bike

                        </option>

                        <option value="Scooter">

                            Scooter

                        </option>

                        <option value="Bicycle">

                            Bicycle

                        </option>

                    </select>

                </div>

                <div className="input-group">

                    <label>

                        <Car size={16}/>

                        Vehicle Number

                    </label>

                    <input

                        type="text"

                        name="number"

                        value={profile?.vehicle?.number || ""}

                        onChange={handleChange}

                        placeholder="KA01AB1234"

                    />

                </div>

                <div className="input-group">

                    <label>

                        <CreditCard size={16}/>

                        Driving License Number

                    </label>

                    <input

                        type="text"

                        name="licenseNumber"

                        value={

                            profile?.vehicle?.licenseNumber || ""

                        }

                        onChange={handleChange}

                        placeholder="DLXXXXXXXXXX"

                    />

                </div>

                <div className="input-group">

                    <label>

                        <ShieldCheck size={16}/>

                        Insurance Number

                    </label>

                    <input

                        type="text"

                        name="insuranceNumber"

                        value={

                            profile?.vehicle?.insuranceNumber || ""

                        }

                        onChange={handleChange}

                        placeholder="Insurance Policy Number"

                    />

                </div>

            </div>

        </div>

    );

}

export default VehicleForm;